.reddi-response-icon{font-variation-settings:"FILL" 1}.rotate-ninety-degrees{-webkit-transform:rotate(90deg);-moz-transform:rotate(90deg);-ms-transform:rotate(90deg);-o-transform:rotate(90deg);transform:rotate(90deg)}
/*# sourceMappingURL=reddi-response-icon.component-CVUJCZ3B.css.map */
